import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlagsPage } from '@/components/admin/featureFlags/FeatureFlagsPage.tsx';

export const Route = createFileRoute('/_app/admin/feature-flags')({
  staticData: { orgScope: 'none' },
  component: FeatureFlagsPage,
});
